/**
* 系统管理 用户管理
*/
<template>
  <div class="page">
    <div class="page-title">用户管理</div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="">
        <el-input size="small" v-model="formInline.name" clearable placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.mobile"  clearable placeholder="输入完整手机号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" v-model="formInline.gender" clearable placeholder="请选择性别">
          <el-option label="男" value="0"></el-option>
          <el-option label="女" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!--        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>-->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <!--      <el-table-column align="center" type="selection" width="50">-->
      <!--      </el-table-column>-->
      <el-table-column align="center" label="照片" width="100">
        <template slot-scope="scope">
          <el-avatar :src="scope.row.avatarUrl"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column align="center"  prop="name" label="用户昵称" width="120">
      </el-table-column>
      <el-table-column align="center"  prop="mobile" label="手机号" width="120">
      </el-table-column>
      <el-table-column align="center"  prop="gender" label="性别" min-width="50" :formatter="sample">
      </el-table-column>
      <el-table-column align="center"  prop="school" label="学校" min-width="50">
      </el-table-column>


      <el-table-column label="操作" min-width="200">
        <template slot-scope="scope">
<!--          <el-button size="mini" type="text" @click="detailUser(scope.$index, scope.row)">查看详情</el-button>-->
          <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
          <el-button size="mini" type="text" @click="deleteUser(scope.$index, scope.row)">删除</el-button>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="用户昵称" prop="name">
          <el-input size="small" v-model="editForm.name" clearable auto-complete="off" maxlength="20"  placeholder="请输入用户名"></el-input>
        </el-form-item>
        <!--        <el-form-item label="证件号" prop="cardId">-->
        <!--          <el-input size="small" v-model="editForm.cardId" type="number" maxlength="18"  clearable  placeholder="请输证件号"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="手机号" prop="mobile">
          <el-input size="small" v-model="editForm.mobile" clearable maxlength="11" auto-complete="off" placeholder="请输手机号"></el-input>
        </el-form-item>
        <el-form-item label="用户地区" prop="city">
          <el-input size="small" v-model="editForm.city" clearable auto-complete="off" placeholder="请输入用户地区"></el-input>
        </el-form-item>
        <el-form-item label="出生日期" prop="birthday">
          <el-date-picker
            v-model="editForm.birthday"
            size="small"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择出生日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="性别" prop="gender" >
          <el-radio-group v-model="editForm.gender" >
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// 导入请求方法
import {
  userList,
  updateWechat,
  delectWeChat,

} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '修改用户',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      // 编辑与添加
      editForm: {
        userId: '',
        name:'',
        cardId:'',
        mobile:'',
        gender:'',
        city:'',
        birthday:'',
      },

      // rules表单验证
      rules: {
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' }

        ],
        city: [
          { required: true, message: '请输入用户地区', trigger: 'blur' },
          {
            validator: function(rule, value, callback) {
              //校验中文的正则：/^[\u4e00-\u9fa5]{0,}$/
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error("请输入中文"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }

        ],
        birthday: [
          { required: true, message: '请输入选择出生日期', trigger: 'blur' }
        ],
        cardId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          {
            pattern: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/,
            required: true,
            message: '请输入正确的身份证号',
            trigger: 'blur'
          }
        ],

        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
            required: true,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],

        gender: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },
      // 删除用户
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      // 重置密码
      resetpsd: {
        userId: '',
        token: localStorage.getItem('logintoken')
      },
      // 用户下线
      offline: {
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        limit: 1,
        page: 10,
        gender: '',
        membership: '',
        mobile: '',
        name:'',

      },
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    sample(row, column, cellValue) {
      if (cellValue == '0') {
        return '男'
      } else if (cellValue == '1') {
        return '女'
      } else {
        return '男'
      }
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // 获取用户列表
      console.log('parameter',parameter);
      userList(parameter).then(res => {
        this.loading = false
        if (res && res.status == 200) {
          this.userData = res.data.list || []
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.data.totalRow || 0
        } else {
          this.$message({
            type: 'error',
            message: (res && (res.message || (res.response && res.response.data && res.response.data.message))) || '用户列表请求失败'
          })
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.pageSize
      this.formInline.limit = parm.currentPage
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      console.log('row----',row)
      if (row != undefined && row != 'undefined') {
        this.editForm.userId = row.id
        this.editForm.name = row.name
        if (row.identityInformation!=null){
          this.editForm.cardId = row.identityInformation.idCardNumber
        }else {
          this.editForm.cardId = ''
        }
        this.editForm.mobile = row.mobile
        this.editForm.gender = row.gender
        this.editForm.birthday = row.birthday
        this.editForm.city = row.city

      }
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 请求方法
          console.log('this.editForm',this.editForm);
          updateWechat(this.editForm)
            .then(res => {
              console.log('res----',res);

              this.editFormVisible = false
              this.loading = false
              if (res.status==200) {
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.getdata(this.formInline)

              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },

    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.unitparm.deptId = data.id
        this.unitparm.deptName = data.name
        //交叉点击节点
      } else {
      }
    },


    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    // 删除用户
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delectWeChat(row.id)
            .then(res => {
              console.log('res----',res)
              if (res.status==200) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                if (this.pageparm.total<=11){
                  this.formInline.limit = 1;
                }
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
    },

    // // 详情
    // detailUser(index, row) {
    //   setTimeout(() => {
    //     this.logining = false
    //     this.$router.push({ path: 'userDetail/detail',query:row })
    //   }, 1000)
    // },



  }
}
</script>

<style scoped>
.page {
  padding: 8px 4px 24px;
}
.page-title {
  font-size: 20px;
  font-weight: 800;
  color: #1f1633;
  margin-bottom: 16px;
}
.user-search {
  margin-top: 0;
  background: #fff;
  padding: 12px 12px 0;
  border-radius: 16px;
  margin-bottom: 12px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/user.vue